import Swiper, {Navigation, Pagination, Autoplay} from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use([Navigation, Pagination, Autoplay]);

window.VegasCarousel = {
	init: function ($carousels) {
		$carousels = $carousels || $('.swiper-container');

		if ($carousels.length) {
			$carousels.each(function () {
				VegasCarousel.carousel($(this));
			});
		}
	},

	carousel: function ($self) {
		let slidesPerView = $self.data('items') || 1,
			slidesPerGroup = $self.data('per-group') || 1,
			spaceBetween = $self.data('margin') || 0,
			dots = !!$self.data('dots') || false,
			dynamicBullets = !!$self.data('dots-dynamic') || false,
			progressbarOpposite = !!$self.data('dots-progress') || false,
			dynamicMainBullets = $self.data('dots-cnt') || 1,
			nav = !!$self.data('nav') || false,
			direction = $self.data('direction') || 'horizontal',
			event = $self.data('event') || 'none',
			height = $self.data('height') || 'auto',
			loop = !!$self.data('loop') || false,
			mousewheel = !!$self.data('mousewheel') || false,
			simulateTouch = $self.data('touch-mouse') !== 'false',
			setWrapperSize = !!$self.data('wrapper-size') || false,
			width = $self.data('width') || false,
			centeredSlides = !!$self.data('wrapper-size') || false,
			freemode = !!$self.data('free-mode') || false,
			transition = $self.data('transition') || false,
			autoplay = $self.data('autoplay-delay') ? {delay: $self.data('autoplay-delay')} : false,
			breakpoints = {
				0: {
					slidesPerView: 1,
					slidesPerGroup: 1,
					spaceBetween: 0,
					autoHeight: true
				},
				767: {
					slidesPerView: 2,
					spaceBetween: spaceBetween
				},
				991: {
					slidesPerView: 2,
					spaceBetween: spaceBetween
				},
				1199: {
					slidesPerView: slidesPerView,
					spaceBetween: spaceBetween
				}
			};

		// Узнаем нужна ли на пагинация и навигация
		let $container = $('#' + $self.attr('id')),
			enable_nav = true,
			count_slides = $container.children('.swiper-wrapper').children('.swiper-slide').length;

		if (count_slides <= slidesPerView && window.innerWidth > 1200) {
			enable_nav = false;

			$container.children('.swiper-pagination').hide();
			$container.children('.swiper-button-next').hide();
			$container.children('.swiper-button-prev').hide();
		}

		let pagination = {};
		if (dots && enable_nav) {
			pagination = {
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					clickable: true,
					progressbarOpposite: progressbarOpposite,
				},
			};

			if (dynamicBullets) {
				pagination.pagination.dynamicBullets = dynamicBullets;
				pagination.pagination.dynamicMainBullets = dynamicMainBullets;
			}
		}

		let navigation = {};
		if (nav && enable_nav) {
			navigation = {
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				}
			}
		}

		let xs = $self.data('xs') || false; // 0px
		if (xs) {
			let params = {
				0: xs
			};

			breakpoints = $.extend(breakpoints, params);
		}

		let md = $self.data('md') || false; // 767px
		if (md) {
			let params = {
				767: md
			};

			breakpoints = $.extend(breakpoints, params);
		}

		let lg = $self.data('lg') || false; // 991px
		if (lg) {
			let params = {
				991: lg
			};

			breakpoints = $.extend(breakpoints, params);
		}

		let wrapper = {};
		if (setWrapperSize) {
			wrapper = {
				setWrapperSize: setWrapperSize
			};
		}

		if (width) {
			wrapper = {
				width: width
			};
		}

		let options = {
			slidesPerGroup: slidesPerGroup,
			direction: direction,
			height: height,
			loop: loop,
			autoplay: autoplay,
			mousewheel: mousewheel,
			simulateTouch: simulateTouch,
			breakpoints: breakpoints,
			centeredSlides: centeredSlides,
			freeMode: freemode
		};


		options = $.extend(options, pagination, navigation, wrapper);

		let swiper = new Swiper('#' + $self.attr('id'), options);
		VegasCarousel.events(swiper, event);
	},

	events: function (self, event) {
		let $container = $(self.$el);
		if (event === 'dots-hover') {
			let $bullets = $container.find('.swiper-pagination-bullet'),
				$link = $container.closest('.vg-shop-prd').find('.prd-link');

			$bullets.hover(function () {
				self.slideTo($(this).index());
			});

			$bullets.click(function () {
				location.href = $link.attr('href');
			})
		}
	}
};